import { render, staticRenderFns } from "./notificationsAdmin.vue?vue&type=template&id=7f510e59&"
import script from "./notificationsAdmin.vue?vue&type=script&lang=js&"
export * from "./notificationsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports